/* Zidne-obloge.hr theme behaviour.
   Everything here is enhancement. The storefront works with JS disabled:
   variant radios and the quantity field post straight to /cart/add, hero
   slide 1 renders at full opacity, and all content is in the HTML. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============ header: transparent over the hero, solid once scrolled ============ */
  var header = document.getElementById('SiteHeader');
  if (header && header.dataset.overlay === 'true') {
    // One class drives the whole overlay state. The transparent background,
    // the transparent border and the light/dark logo swap are all CSS rules
    // keyed off .is-overlay, so there is no multi-class toggle to get wrong.
    var applyHeaderState = function () {
      header.classList.toggle('is-overlay', window.scrollY <= 40);
    };
    applyHeaderState();
    window.addEventListener('scroll', applyHeaderState, { passive: true });
  }

  /* ============ mobile menu ============ */
  var menu = document.getElementById('MobileMenu');
  var openBtn = $('[data-menu-open]');
  var closeBtn = $('[data-menu-close]');
  var setMenu = function (open) {
    if (!menu) return;
    menu.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    // Keyboard users must land inside the dialog on open and back on the
    // trigger on close, or focus stays behind the overlay (WCAG 2.4.3).
    if (open && closeBtn) closeBtn.focus();
    else if (!open && openBtn) openBtn.focus();
  };
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  // Most menu links are same-page section anchors (/#primjena, /#montaza): no
  // navigation happens, so without this the overlay stays open and the tap
  // looks ignored. Closing on any link click also covers real page
  // navigations, where it is a harmless no-op.
  if (menu) {
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
  }

  /* ============ video facade ============ */
  /* The installation video ships as a poster and a play button, with no <video>
     element at all. preload="none" was not respected everywhere: PageSpeed kept
     downloading the full 1.66 MB while local Lighthouse downloaded none of it.
     With no src in the DOM there is nothing to fetch under any preload policy.
     Clicking swaps in a real player and starts it, so it is still one click. */
  var facade = $('[data-video-facade]');
  if (facade) {
    facade.addEventListener('click', function () {
      var video = document.createElement('video');
      video.src = facade.getAttribute('data-video-facade');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.className = 'h-full w-full object-cover';
      facade.replaceWith(video);
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked: controls are there */ });
    });
  }

  /* ============ gallery: reveal the rest on demand ============ */
  /* Twelve of the eighteen photographs ship without a src. Native lazy loading
     is not a byte budget: Chrome widens its lazy threshold on slow connections,
     so a 4G phone was fetching 1,572 KiB of gallery it never scrolled to.
     The button is unhidden here, which means a visitor without JS never sees a
     control that cannot work; they get all eighteen from the <noscript> block. */
  var galleryToggle = $('[data-gallery-toggle]');
  if (galleryToggle) {
    galleryToggle.hidden = false;
    galleryToggle.addEventListener('click', function () {
      $$('[data-gallery-more]').forEach(function (fig) {
        var img = $('img', fig);
        if (img && img.getAttribute('data-src')) {
          var ss = img.getAttribute('data-srcset');
          if (ss) img.setAttribute('srcset', ss);
          img.setAttribute('src', img.getAttribute('data-src'));
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        }
        fig.classList.remove('hidden');
      });
      galleryToggle.remove();
    });
  }

  /* ============ hero slideshow ============ */
  var hero = $('[data-hero]');
  if (hero) {
    var slides = $$('[data-hero-slide]', hero);
    var dots = $$('[data-hero-go]', hero);
    var labelEl = $('[data-hero-label]', hero);
    var indexEl = $('[data-hero-index]', hero);
    var toggle = $('[data-hero-toggle]', hero);
    var LABELS = slides.map(function (s) {
      var img = $('img', s);
      return img ? (img.getAttribute('alt') || '').split('·').pop().trim() : '';
    });
    var current = 0, paused = false, timer = null;

    /* Slides 2..n ship with data-src instead of src. They sit at inset-0 of the
       first viewport, so loading="lazy" does not defer them and all six raced
       the LCP image. Hydrate them once the page has loaded, and on demand if a
       control asks for a slide before that happens. */
    var hydrate = function (slide) {
      var img = slide && $('[data-hero-img]', slide);
      if (!img || !img.getAttribute('data-src')) return;
      var ss = img.getAttribute('data-srcset');
      if (ss) img.setAttribute('srcset', ss);
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    };
    /* Prime only the NEXT slide after load, not all of them. Hydrating all five
       cost 380 KB for a visitor who leaves before the first 6s transition. One
       is primed so the first crossfade is never blank; the rest arrive just in
       time from show(). */
    var primeNext = function () { hydrate(slides[1]); };
    if (document.readyState === 'complete') setTimeout(primeNext, 0);
    else window.addEventListener('load', primeNext);

    var kenBurns = function (slide, on) {
      var img = $('[data-hero-img]', slide);
      if (!img || reduced) return;
      if (on) {
        img.classList.remove('scale-100', 'duration-0');
        img.classList.add('scale-[1.12]', 'transition-transform', 'duration-[6500ms]', 'ease-out');
      } else {
        img.classList.remove('scale-[1.12]', 'duration-[6500ms]');
        img.classList.add('scale-100', 'duration-0');
      }
    };

    // Outgoing slides keep their zoom through the 2s crossfade and reset only
    // once fully transparent; resetting at swap time snapped the image back to
    // scale-100 in plain view. transitionend bubbles from the img too, so
    // filter to the slide's own opacity transition.
    slides.forEach(function (s) {
      s.addEventListener('transitionend', function (e) {
        if (e.target !== s || e.propertyName !== 'opacity') return;
        if (s.getAttribute('aria-hidden') === 'true') kenBurns(s, false);
      });
    });

    var show = function (next) {
      current = (next + slides.length) % slides.length;
      // The one being shown, plus the one after it so the next crossfade is
      // ready. Also covers a dot or arrow pressed before window.load.
      hydrate(slides[current]);
      hydrate(slides[(current + 1) % slides.length]);
      slides.forEach(function (s, i) {
        var active = i === current;
        s.classList.toggle('opacity-100', active);
        s.classList.toggle('opacity-0', !active);
        if (active) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        if (active) {
          // Reset while still transparent (invisible), commit the reset with a
          // reflow, then start this cycle's zoom from scale-100. Covers slides
          // whose fade-out reset never fired (e.g. backgrounded tab).
          kenBurns(s, false);
          void s.offsetWidth;
          kenBurns(s, true);
        }
      });
      dots.forEach(function (d, i) {
        var active = i === current;
        d.classList.toggle('text-paper', active);
        d.classList.toggle('text-paper/40', !active);
        var rule = $('[data-hero-rule]', d);
        if (rule) rule.classList.toggle('hidden', !active);
      });
      if (labelEl) labelEl.textContent = LABELS[current] || '';
      if (indexEl) indexEl.textContent = ('0' + (current + 1)).slice(-2);
    };

    var start = function () { if (!paused && !reduced) timer = setInterval(function () { show(current + 1); }, 6000); };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };

    dots.forEach(function (d, i) { d.addEventListener('click', function () { stop(); show(i); start(); }); });
    var prev = $('[data-hero-prev]', hero); var next = $('[data-hero-next]', hero);
    if (prev) prev.addEventListener('click', function () { stop(); show(current - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); show(current + 1); start(); });

    if (toggle && !reduced) {
      toggle.classList.remove('hidden');
      toggle.classList.add('grid');
      toggle.addEventListener('click', function () {
        paused = !paused;
        toggle.setAttribute('aria-label', paused ? 'Pokreni prikaz' : 'Zaustavi prikaz');
        $('[data-hero-icon-pause]', toggle).classList.toggle('hidden', paused);
        $('[data-hero-icon-play]', toggle).classList.toggle('hidden', !paused);
        if (paused) stop(); else start();
      });
    }

    kenBurns(slides[0], true);
    start();
  }

  /* ============ lightbox ============ */
  var lightbox = document.getElementById('Lightbox');
  if (lightbox) {
    var lbImg = $('[data-lightbox-img]', lightbox);
    var lbClose = $('[data-lightbox-close]', lightbox);
    var lbReturnFocus = null;
    var openLightbox = function (src, alt) {
      if (!src) return;
      lbImg.src = src;
      lbImg.alt = alt || '';
      lbImg.addEventListener('load', function onLoad() {
        lbImg.setAttribute('width', lbImg.naturalWidth);
        lbImg.setAttribute('height', lbImg.naturalHeight);
        lbImg.removeEventListener('load', onLoad);
      });
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      lbReturnFocus = document.activeElement;
      if (lbClose) lbClose.focus();
    };
    var closeLightbox = function () {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lbReturnFocus && lbReturnFocus.focus) lbReturnFocus.focus();
      lbReturnFocus = null;
    };
    // The close button is the dialog's only focusable control; keep Tab on it
    // instead of letting focus escape into the page behind the overlay.
    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && lbClose) {
        e.preventDefault();
        lbClose.focus();
      }
    });

    $$('[data-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = $('img', btn);
        var src = btn.dataset.full || (img && (img.dataset.full || img.src));
        openLightbox(src, img ? img.alt : '');
      });
    });
    lightbox.addEventListener('click', function (e) { if (e.target !== lbImg) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!lightbox.hidden) closeLightbox();
      else if (menu && !menu.hidden) setMenu(false);
    });
  }

  /* ============ panel cards: hovering a swatch previews that colour ============ */
  $$('[data-panel-card]').forEach(function (card) {
    var img = $('[data-card-image]', card);
    if (!img) return;
    $$('[data-swatch]', card).forEach(function (sw) {
      if (!sw.dataset.img) return;
      sw.addEventListener('mouseenter', function () { img.src = sw.dataset.img; });
    });
    card.addEventListener('mouseleave', function () { img.src = img.dataset.default; });
  });

  /* ============ product: colour swap, quantity in m², running total ============ */
  var mainImage = document.getElementById('ProductMainImage');
  var colourLabel = $('[data-selected-colour]');
  var area = document.getElementById('area');
  var lineTotal = $('[data-line-total]');

  var eur = function (n) {
    try { return new Intl.NumberFormat('hr-HR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n); }
    catch (e) { return n.toFixed(0) + ' EUR'; }
  };

  var updateTotal = function () {
    if (!area || !lineTotal) return;
    var unit = parseFloat(area.dataset.price) || 0;
    lineTotal.textContent = eur(Math.max(1, parseInt(area.value, 10) || 1) * unit);
  };

  $$('input[name="id"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (mainImage && radio.dataset.variantImage) {
        mainImage.src = radio.dataset.variantImage;
        if (radio.dataset.variantFull) mainImage.dataset.full = radio.dataset.variantFull;
      }
      if (colourLabel) {
        var name = radio.parentElement.getAttribute('title');
        if (name) colourLabel.textContent = name;
      }
    });
  });

  if (area) {
    var clamp = function (n) { return Math.max(1, Math.round(n || 1)); };
    var step = function (d) { area.value = clamp(parseFloat(area.value) + d); updateTotal(); };
    var up = $('[data-qty-up]'); var down = $('[data-qty-down]');
    if (up) up.addEventListener('click', function () { step(1); });
    if (down) down.addEventListener('click', function () { step(-1); });
    area.addEventListener('input', function () { updateTotal(); });
    area.addEventListener('change', function () { area.value = clamp(parseFloat(area.value)); updateTotal(); });
    updateTotal();
  }

  /* ============ homepage calculator ============ */
  var home = $('[data-home-calculator]');
  if (home) {
    var panelSel = $('[data-calc-panel]', home);
    var wIn = $('[data-calc-w]', home);
    var hIn = $('[data-calc-h]', home);
    var outM2 = $('[data-calc-m2]', home);
    var outNote = $('[data-calc-note]', home);
    var outTotal = $('[data-calc-total]', home);

    var recalc = function () {
      var unit = parseFloat(panelSel && panelSel.value) || 0;
      var name = panelSel && panelSel.selectedOptions[0] ? panelSel.selectedOptions[0].dataset.name : '';
      var wall = Math.max(0, (parseFloat(wIn.value) || 0) * (parseFloat(hIn.value) || 0));
      var boxes = Math.ceil(wall);
      outM2.textContent = boxes + ' m²';
      outNote.textContent = 'Zid ' + wall.toFixed(2).replace('.', ',') + ' m², zaokruženo na cijeli m².' +
        (name && unit ? ' ' + name + ' · ' + eur(unit) + '/m².' : '');
      outTotal.textContent = unit ? eur(boxes * unit) : '-';
    };
    [panelSel, wIn, hIn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', recalc);
      el.addEventListener('change', recalc);
    });
    recalc();
  }

  /* ============ statement reveal ============ */
  // Only the brand statement band animates in; nothing else on the page gets a
  // scroll reveal. Elements are hidden by JS only when they start below the
  // fold, so content stays visible if JS never runs (progressive enhancement)
  // and for reduced-motion visitors. Fires once per element, tracking the
  // element itself.
  var revealEls = $$('[data-reveal]');
  if (revealEls.length && !reduced && 'IntersectionObserver' in window) {
    var armed = revealEls.filter(function (el) {
      return el.getBoundingClientRect().top > window.innerHeight;
    });
    armed.forEach(function (el) { el.classList.add('js-reveal-pending'); });
    if (armed.length) {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('js-reveal-in');
          revealIO.unobserve(entry.target);
        });
      }, { threshold: 0.35 });
      armed.forEach(function (el) { revealIO.observe(el); });
    }
  }

  /* ============ YouTube consent facade ============ */
  // The iframe never exists in the HTML; it is created only on click so no
  // request reaches Google before the visitor explicitly asks for the video.
  $$('[data-youtube-facade]').forEach(function (facade) {
    var btn = $('[data-youtube-load]', facade);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var id = facade.getAttribute('data-youtube-id');
      if (!id) {
        console.error('[youtube-facade] missing data-youtube-id');
        return;
      }
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?rel=0&autoplay=1';
      iframe.title = 'Video ugradnje 3D zidnih panela';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      iframe.setAttribute('allowfullscreen', '');
      iframe.className = 'h-full w-full';
      facade.replaceChild(iframe, btn);
    });
  });
})();
